
















import { Component } from 'vue-mixin-decorator';
import axios from 'axios';
import RepositoryFactory from '@/repository/RepositoryFactory';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import * as DesignCode from '@/classification/DesignCode';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
    },
  },
)
export default class Tokushoho extends BaseView {
  private main = '';

  private inquiryUrl = '';

  async mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const ExamRepository = RepositoryFactory.get().exam;
    ExamRepository.getExamDesignResource(DesignCode.INQUIRY_URL).then((response) => {
      if (response.status === 200 && response.data !== undefined) {
        this.inquiryUrl = response.data.display_text;
        this.getTokushoMain();
      }
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  async getTokushoMain() {
    const ExamRepository = RepositoryFactory.get().exam;
    ExamRepository.getExamTextResource('tokushoho').then((response) => {
      if (response.status !== 200 || response.data === undefined) {
        this.getTokushoFromStatic();
        return;
      }
      const tokushoHtml = response.data.text;
      if (typeof tokushoHtml === 'string') {
        this.main = tokushoHtml.replace('{{INQUIRY_URL}}', this.inquiryUrl);
      } else {
        this.getTokushoFromStatic();
      }
    });
  }

  async getTokushoFromStatic() {
    let baseUrl = process.env.VUE_APP_BASE_URL;
    if (baseUrl === 'http://localhost:8080') {
      baseUrl = 'http://localhost:8030';
    }

    const main = await axios.get(`${baseUrl}/static/tokushoho_main.html`)
      .then((response) => response.data);
    if (typeof main === 'string') {
      this.main = main.replace('{{INQUIRY_URL}}', this.inquiryUrl);
    }
  }
}
